import {Card, CardContent, Container, Typography } from "@mui/material"


export const SessionExpiredCard = () => {
    return (
        <Container maxWidth="sm">
            <Card sx={{marginTop: "20vh", textAlign: "center"}}>
                <CardContent>
                    <Typography variant="h5" component="h2" gutterBottom>
                        Session Expired
                    </Typography>
                    <Typography variant="body1" color="textSecondary">
                        Your session has expired and you will be redirected to log in...
                    </Typography>
                </CardContent>
            </Card>
        </Container>
    )
}